module.exports = __webpack_public_path__ + "img/image-desktop.c100b926.svg";